// src/pagesv2/user/UserProfileMobile.jsx

import { EditProfile } from '../../cmps/UserProfile/EditProfile'
import { UserDetails } from '../../cmps/UserProfile/UserDetails'
import { UserComments } from '../../cmps/UserProfile/UserComments'
import { MALImport } from '../../cmps/UserProfile/MALImport'
import { UserPosts } from '../../cmps/UserProfile/UserPosts'
import { UserReviews } from '../../cmps/UserProfile/UserReviews'
import { UserWatchlist } from '../../cmps/UserProfile/UserWatchlist/UserWatchlist'
import { Button } from '../../cmps/ui/elements'
import { CircleRed } from '../../cmps/ui/icons/user'

export function UserProfileMobile({
  user,
  userId,
  reviews,
  comments,
  loggedInUser,
  isEditing,
  handleEdit,
  handleCloseEdit,
  activeTab,
  setActiveTab,
  recommendationsCount,
  disappointmentsCount,
  tabs,
  stats,
}) {
  return (
    <>
      <div className="min-h-screen relative">
        <div className="flex flex-col">
          <div
            className="w-full h-48 bg-no-repeat bg-center bg-cover"
            style={{
              backgroundImage: `url(${user.coverImage})`,
              backgroundColor: '#1a1a1a',
              maskImage:
                'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 40%, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0) 100%)',
              WebkitMaskImage:
                'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 40%, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0) 100%)',
            }}
          ></div>

          <div className="flex flex-col z-10 gap-5">
            <img
              src={user.image}
              alt="User icon"
              className="w-24 h-24 rounded-full border-2 border-primary object-cover mx-auto mt-[-50px]"
            />
            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-3">
                <h1 className="text-4xl text-white text-center">
                  {user.nickname}
                </h1>
                <div className="flex gap-2 justify-center items-center">
                  <p className="text-muted text-xs text-center">
                    {user.userTag}
                  </p>
                  <div className="w-1 h-1 bg-[#707070] rounded-full" />
                  <span className="text-muted text-xs">
                    {new Date(user.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
              <div className="flex gap-10 items-center justify-center">
                {stats.map((stat, idx) => (
                  <div
                    key={idx}
                    className="flex flex-col items-center justify-center"
                  >
                    <div
                      className="relative w-[49px] h-[49px]"
                      aria-label={`${stat.label}: ${stat.value}`}
                    >
                      <CircleRed />
                      <span className="absolute inset-0 flex items-center justify-center text-white font-semibold text-sm pointer-events-none">
                        {stat.value}
                      </span>
                    </div>
                    <p className="text-softText">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {loggedInUser &&
          (loggedInUser._id === userId || loggedInUser.role === 'admin') && (
            <div className="absolute top-10 left-10">
              <Button
                text="ערוך פרופיל"
                width={120}
                height={50}
                fontSize="text-lg"
                textColor="text-white"
                bgColor="fill-background"
                onClick={handleEdit}
                aria-label="עריכת פרופיל המשתמש"
                title="ערוך את הפרופיל שלך"
              />
            </div>
          )}
        {isEditing && <EditProfile user={user} onClose={handleCloseEdit} />}

        <div className="mt-11 overflow-x-auto scrollbar-hide">
          <div className="flex gap-6 justify-start px-4 min-w-max whitespace-nowrap transition-all duration-300">
            {tabs
              .filter((tab) => tab.condition === undefined || tab.condition)
              .map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`tab ${
                    activeTab === tab.key
                      ? 'text-white border-b-[1px] border-primary pb-2 px-6'
                      : 'text-muted border-b-[1px] border-[#3F3F3F] pb-2 px-6 hover:text-white hover:border-primary transition duration-300'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
          </div>
        </div>

        <div className="">
          {activeTab === 'watchOrReadList' && <UserWatchlist userId={userId} />}
          {activeTab === 'userComments' && <UserComments userId={userId} />}
          {activeTab === 'userDetails' && <UserDetails user={user} />}
          {activeTab === 'userReviews' && <UserReviews userId={userId} />}
          {activeTab === 'userPosts' && <UserPosts userId={userId} />}
          {activeTab === 'importMalList' &&
            loggedInUser &&
            (loggedInUser._id === userId || loggedInUser.role === 'admin') && (
              <MALImport userId={userId} />
            )}
        </div>
      </div>
    </>
  )
}
